/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SearchImagesResponse, SearchImagesVars } from '../openapi-types.gen.js';

export type { SearchImagesResponse, SearchImagesVars } from '../openapi-types.gen.js';

export const useSearchImages = createMutationHook<SearchImagesVars, SearchImagesResponse, unknown>({
  specName: 'useSearchImages',
  path: '/v1/images/search',
  method: 'POST',
  resolveUrl: (vars: SearchImagesVars) => `/v1/images/search`,
  buildBody: (vars: SearchImagesVars) => ({ query: vars.query, cursor: vars.cursor }),
  parseResponse: (raw: unknown): SearchImagesResponse => raw as SearchImagesResponse,
  
  
  
});
